import { connect } from 'react-redux';
import { onSubmit } from './events/onSubmit';
import { onSkip } from './events/onSkip';
import { IApplicationState } from '../../../../../../types/types';
import { Poll } from '../../../../base/components/Poll/components/Poll/Poll';
import { IPollEvents, IPollFields } from '../../../../base/components/Poll/components/Poll/types';
import { EPollQuestionVariant } from '../../../../base/components/Poll/components/PollQuestion/types';
import { getShowTemplatePoll } from './selectors/getShowTemplatePoll';
import { TEMPLATE_POLL_MAX_START_FOR_REVIEW, TEMPLATE_POLL_REVIEW_TITLE, TEMPLATE_POLL_TITLE } from './constants';
import { onShow } from './events/onShow';
import { CLASS_POLL } from '../../../../base/components/Poll/components/constants';

const mapStateToProps = (
    state: IApplicationState,
): IPollFields => {
    const isTrialExtendOpen = !!document.querySelector('.dialog-blocker__trial-dialog');
    let isAnotherPoll = false;
    const anotherPoll = document.querySelector(`.${CLASS_POLL}`) as HTMLElement;
    if (anotherPoll) {
        isAnotherPoll = !anotherPoll.parentElement.className.includes('poll-placeholder--template');
    }
    const isShow = !isAnotherPoll && !isTrialExtendOpen;
    return {
        isShow: isShow && getShowTemplatePoll(state),
        title: TEMPLATE_POLL_TITLE,
        maxStarsForReview: TEMPLATE_POLL_MAX_START_FOR_REVIEW,
        reviewTitle: TEMPLATE_POLL_REVIEW_TITLE,
        questionsList: [{ question: '' }],
        variant: EPollQuestionVariant.STAR,
    };
}

const mapDispatchToProps = (
    dispatch: any,
): IPollEvents => {
    return {
        onShow: () => dispatch(onShow()),
        onSkip: () => dispatch(onSkip()),
        onSubmit: (results) => dispatch(onSubmit(results))
    };
}

export const TemplatePollHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Poll);

TemplatePollHOC.displayName = 'TemplatePollHOC';
